import { NotFoundRouteProps } from '@tanstack/react-router';
import { NotFoundPage } from '~/pages/not-found';

export const DefaultNotFoundComponent: React.FC<NotFoundRouteProps> = () => {
  return <NotFoundPage />;
};
